import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { DynFormSectionResponseBase } from '../../model/dyn-form/api/dyn-form-section-response.model';
import { DynFormSectionBase } from '../../model/dyn-form/dyn-form-section.model';
import { SectionLayoutMetadata } from '../../model/dyn-form/form-metadata/layout/section-layout.model';
import { DynFormBase } from '../../model/dyn-form/dyn-form.model';

@Injectable({
    providedIn: 'root'
})
export class DynFormService {

    protected resourceUrl: string = "/rest/adminens/dynform"

    constructor(private http: HttpClient) { }


    public putDynFormSection(dfs: DynFormSectionBase): Observable<DynFormSectionResponseBase> {
        return this.http.post<DynFormSectionResponseBase>(`${this.resourceUrl}/putFormSection`, dfs).pipe(map(r => DynFormSectionResponseBase.from(r)))
    }

    public putFormSectionOrder(section: { id: number, order: number }[]): Observable<DynFormSectionResponseBase> {
        return this.http.post<DynFormSectionResponseBase>(`${this.resourceUrl}/putFormSectionOrder`, section).pipe(map(r => DynFormSectionResponseBase.from(r)))
    }

    public loadSection(sectionId: number): Observable<SectionLayoutMetadata> {
        return this.http.get<SectionLayoutMetadata>(`${this.resourceUrl}/getJsonSectionForm/${sectionId}`).pipe(map(r => r))
    }

    public saveSection(sectionId: number, slm: SectionLayoutMetadata): Observable<boolean> {
        return this.http.post<boolean>(`${this.resourceUrl}/putJsonSectionForm/${sectionId}`, slm).pipe(map(r => r))
    }

    public findDynFormByProcedureFormId(procedureFormId: number): Observable<{ ok: boolean, messageCode: string, entity: DynFormBase }> {
        return this.http.post<{ ok: boolean, messageCode: string, entity: DynFormBase }>(`${this.resourceUrl}/findDynFormByProcedureFormId`, procedureFormId).pipe(map(r => {
            if (r.ok) {
                r.entity = DynFormBase.from(r.entity)
            }

            return r
        }))
    }

}
